










import Enumerable from "linq";
import { Component, Mixins, Watch, Emit } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { DocumentKind } from "../../../domain/document";
import { ModelEditableMixin } from "../../system/mixins";
import { StandardOption } from "../../system/selectors/mixins";
import OptionDropDownSelector from "../../system/selectors/OptionDropDownSelector.vue";
import { FixedLoading } from "../../system";

@Component({
  components: {
    selector: OptionDropDownSelector,
    FixedLoading
  }
})
export default class DocumentKindDropDownSelector extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      options: null as StandardOption<DocumentKind>[],
    };
  }
  options: StandardOption<DocumentKind>[];

  get isLoaded(): boolean {
    return !!this.options;
  }

  created() {
    const repository = DomainRegistry.document.getDocumentKindRepository();
    repository.getAllEntities()
      .then(d => this.options = this.toOptions(d))
      .catch(e => {
        this.$error(
          this.$wording.format.attributes.name + "種別情報取得失敗",
          this.$wording.format.attributes.name + "種別情報を取得できませんでした。",
          e,
        );
      });
  }

  private toOptions(source: DocumentKind[]): StandardOption<DocumentKind>[] {
    return Enumerable.from(source)
      .select(s => new StandardOption<DocumentKind>(s.name, s))
      .toArray();
  }

  areDocumentKindIdsEqual(source: DocumentKind, destination: DocumentKind): boolean {
    return DocumentKind.areEqual(source, destination);
  }

  @Watch("isLoaded")
  onIsLoadedUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.loaded(this.options);
    }
  }

  @Emit()
  loaded(options: StandardOption<DocumentKind>[]): void {}
}
